import { FC, ReactNode } from "react";
import { useTranslations } from "next-intl";
import classNames from "classnames";

type FormRowProps = {
  className?: string;
  children?: ReactNode;
  rowLabel?: string;
  translateLabel?: boolean;
};

const FormRow: FC<FormRowProps> = ({
  className,
  children,
  rowLabel,
  translateLabel = true,
}) => {
  const t = useTranslations();

  return (
    <div className={classNames("mt-5", className)}>
      {rowLabel && (
        <h3 className="mb-[10px] text-sm font-medium uppercase text-black/30">
          {translateLabel ? t(rowLabel) : rowLabel}
        </h3>
      )}
      {children}
    </div>
  );
};

export { FormRow };
